<template>
  <!-- 联系我们 -->
  <div class="contact_container">
    <div class="top-img_wrap">
      <DragCarousel :images="imgData"></DragCarousel>
    </div>
    <NavTools></NavTools>
    <router-view></router-view>
  </div>
</template>

<script>
  import DragCarousel from '@/components/drag-carousel/index.vue';
  import NavTools from '@/layouts/components/NavTools.vue';
  export default {
    components: { DragCarousel, NavTools },
    data() {
      return {
        imgData: [
          {
            src: require('@/assets/img/contact/introTopImg.jpg'),
            alt: '关于我们'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
.contact_container {
  width: 100%;
  height: 100%;
}
.top-img_wrap {
  margin-top: 80px;
  @media screen and (max-width: 768px) {
    margin: 0;
  }
}
</style>
